import React, { useEffect } from 'react';
import { Button, notification } from 'antd';
import { useTranslation } from '../../i18n/useTranslation';
import { sanitizeUrl } from './utils/sanitizationUtils';

export const Notification = ({ exportEntity }: any) => {
    const [api, contextHolder] = notification.useNotification();
    const { t } = useTranslation();

    useEffect(() => {
        const key = `open${Date.now()}`;

        const title = exportEntity?.exportDownloadLink ? t('Export Completed') : t('Export Started');
        const content = exportEntity?.exportDownloadLink ? t('FILE_READY_DOWNLOAD_DESC') : t('FILE_READY_EMAIL_DESC');

        // Sanitize download link to prevent XSS
        const safeDownloadLink = exportEntity?.exportDownloadLink ? sanitizeUrl(exportEntity.exportDownloadLink) : null;

        api.open({
            message: <span />,
            description: (
                <div className="notification-description">
                    <div style={{ maxWidth: 300 }}>
                        <div style={{ fontWeight: 'bold' }}>{title}</div>
                        <span>{content}</span>
                        {safeDownloadLink && (
                            <Button
                                type="link"
                                target="_blank"
                                className="ml-1"
                                href={safeDownloadLink}
                                style={{ textDecoration: 'underline', color: '#70B246' }}
                            >
                                {t('Click here')}
                            </Button>
                        )}
                    </div>
                    <Button type="link" className="f-color-gray-s100 shrink-0" onClick={() => notification.close(key)}>
                        {t('CLOSE')}
                    </Button>
                </div>
            ),
            closeIcon: <></>,
            key,
            duration: 10,
            className: 'notification-success',
        });
    }, [exportEntity, api, t]); // Dependency array ensures effect runs only when exportEntity changes

    return <>{contextHolder}</>; // This component does not render anything
};
